import { makeStore, AppStore, InitialStoreState } from './store';

let store: AppStore | undefined;

export function getOrCreateStore(initialState?: InitialStoreState, texts?: { [key: string]: string }) {
  const isServer = typeof window === 'undefined';
  const preloadedState = initialState ? { ...initialState, locale: texts } : { locale: texts };

  if (isServer) {
    // Always create a new store on the server
    return makeStore(preloadedState);
  }

  if (!store) {
    // On the client, create the store once with merged state
    store = makeStore(preloadedState);
  }
  // Do not recreate or rehydrate the store after initial client hydration
  return store;
}
